import { Chip } from '@mui/material';

// Unmapped statuses (draft, future states) fall back to the neutral pill.
const STATUS_CHIP_COLOR: Record<string, 'success' | 'info' | 'error'> = {
  processed: 'success',
  final: 'success',
  ready: 'success',
  processing: 'info',
  error: 'error',
  failed: 'error',
};

export interface ArtifactStatusChipProps {
  /** Lifecycle or unified asset status, any casing — the chip normalizes it. */
  status: string;
  'data-testid'?: string;
}

/**
 * Status pill for artifact surfaces (detail headers, list rows): semantic
 * states in themed colors with white text, draft/unmapped as the light
 * neutral pill.
 */
export const ArtifactStatusChip = ({
  status,
  'data-testid': dataTestId,
}: ArtifactStatusChipProps) => {
  const normalized = status.toLowerCase();
  const semanticColor = STATUS_CHIP_COLOR[normalized];
  const label = normalized.charAt(0).toUpperCase() + normalized.slice(1);

  return (
    <Chip
      size="small"
      label={label}
      color={semanticColor}
      data-testid={dataTestId}
      sx={{
        fontWeight: 400,
        ...(semanticColor
          ? { color: 'common.white' }
          : {
              // TODO: no VDS token for the #000 @ 8% draft fill — needs designer input
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              color: 'text.primary',
            }),
      }}
    />
  );
};
